import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { fadeUp, viewportOnce } from "../../lib/motion";
import { SECTORS_CLOSING } from "../../lib/sectors";

const SectorsClosing = () => (
    <section
        data-testid="sectors-closing-section"
        className="relative border-t border-white/10 bg-surface/40 py-24 lg:py-32"
    >
        <div className="mx-auto max-w-[1600px] px-6 md:px-10 lg:px-16">
            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                className="max-w-4xl"
            >
                <p className="flex items-center gap-3 font-mono text-[13px] tracking-[0.3em] text-mist">
                    <span className="h-1.5 w-1.5 bg-accent" />
                    THE PATH FORWARD
                </p>
                <h2
                    data-testid="sectors-closing-headline"
                    className="mt-8 font-display text-3xl font-semibold leading-[1.12] text-white md:text-5xl"
                >
                    {SECTORS_CLOSING.headingA}
                    <span className="text-accent"> </span>
                    {SECTORS_CLOSING.headingB}
                </h2>
                <p className="mt-6 max-w-2xl text-[16px] leading-relaxed text-mist">
                    {SECTORS_CLOSING.copy}
                </p>
                <div className="mt-10 flex flex-wrap gap-4">
                    <Link
                        to="/join-the-pilot"
                        data-testid="sectors-closing-get-started"
                        className="group inline-flex items-center gap-2 bg-accent px-7 py-4 text-[16px] font-semibold text-white transition-colors duration-300 hover:bg-[#ff7026]"
                    >
                        Get Started
                        <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5" />
                    </Link>
                    <Link
                        to="/how-it-works"
                        data-testid="sectors-closing-how-it-works"
                        className="inline-flex items-center border border-white/25 px-6 py-4 text-[16px] font-medium text-white transition-colors duration-300 hover:border-accent"
                    >
                        Explore How It Works
                    </Link>
                </div>
            </motion.div>
        </div>
    </section>
);

export default SectorsClosing;
